/* AutoChimp wishlist. Loaded by snippets/ac-wishlist.liquid (config in window.AC_WL_CFG). */
(function () {
  'use strict';
  if (window.ACWishlist) return;
  var KEY = 'ac_wishlist_v1';
  var CFG = window.AC_WL_CFG || {};
  var PAGE_URL = CFG.page || '/pages/wishlist';
  var ROOT = CFG.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.7l-1.2-1.1C6.3 15.6 3.3 12.9 3.3 9.5 3.3 6.8 5.4 4.7 8.1 4.7c1.5 0 3 .7 3.9 1.9.9-1.2 2.4-1.9 3.9-1.9 2.7 0 4.8 2.1 4.8 4.8 0 3.4-3 6.1-7.5 10.1L12 20.7z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    refreshAll();
  }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) {
    var list = read(), i = list.indexOf(h);
    if (i === -1) list.unshift(h); else list.splice(i, 1);
    write(list);
    return i === -1;
  }
  function remove(h) { write(read().filter(function (x) { return x !== h; })); }
  function handleFromHref(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---- product cards ---- */
  function decorateCards(scope) {
    (scope || document).querySelectorAll('.productitem').forEach(function (card) {
      if (card.querySelector('.ac-wl-heart')) return;
      var box = card.querySelector('.productitem__image-container');
      var link = card.querySelector('a[href*="/products/"]');
      var h = link && handleFromHref(link.getAttribute('href'));
      if (!box || !h) return;
      var title = (card.querySelector('.productitem--title') || {}).textContent || 'this product';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ac-wl-heart';
      b.setAttribute('data-ac-wl', h);
      b.setAttribute('data-ac-wl-title', title.trim());
      b.innerHTML = HEART;
      box.appendChild(b);
    });
    refreshAll();
  }

  /* ---- product page ---- */
  function decorateProductPage() {
    var h = handleFromHref(location.pathname);
    if (!h || !/\/products\//.test(location.pathname)) return;
    var atc = document.querySelector('.product-form--atc');
    if (!atc || atc.querySelector('.ac-wl-save')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ac-wl-save';
    b.setAttribute('data-ac-wl', h);
    b.setAttribute('data-ac-wl-title', (document.querySelector('.product-title, h1') || {}).textContent ? document.querySelector('.product-title, h1').textContent.trim() : 'this product');
    b.innerHTML = HEART + '<span data-ac-wl-label>Save to wishlist</span>';
    atc.appendChild(b);
  }

  /* ---- header link ---- */
  function decorateHeader() {
    document.querySelectorAll('.site-header-cart').forEach(function (cart) {
      if (cart.querySelector('.ac-wl-link')) return;
      var a = document.createElement('a');
      a.className = 'ac-wl-link';
      a.href = PAGE_URL;
      a.setAttribute('aria-label', 'Wishlist');
      a.innerHTML = HEART + '<span class="ac-wl-link__count" data-ac-wl-count hidden></span>';
      cart.insertBefore(a, cart.firstChild);
    });
  }

  /* Idempotent: only touches the DOM when a value actually changes, so the MutationObserver
     below never re-triggers itself. */
  function setAttr(el, k, v) { if (el.getAttribute(k) !== v) el.setAttribute(k, v); }
  function refreshAll() {
    var list = read();
    document.querySelectorAll('[data-ac-wl]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-ac-wl')) !== -1;
      var t = b.getAttribute('data-ac-wl-title') || 'this product';
      setAttr(b, 'aria-pressed', on ? 'true' : 'false');
      setAttr(b, 'aria-label', (on ? 'Remove ' : 'Save ') + t + (on ? ' from wishlist' : ' to wishlist'));
      setAttr(b, 'title', on ? 'Remove from wishlist' : 'Save to wishlist');
      var lbl = b.querySelector('[data-ac-wl-label]');
      var txt = on ? 'Saved to wishlist' : 'Save to wishlist';
      if (lbl && lbl.textContent !== txt) lbl.textContent = txt;
    });
    document.querySelectorAll('[data-ac-wl-count]').forEach(function (c) {
      var n = String(list.length);
      if (c.textContent !== n) c.textContent = n;
      if (c.hidden !== (list.length === 0)) c.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ac-wl]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b.getAttribute('data-ac-wl'));
    if (document.querySelector('[data-ac-wishlist-page]')) renderPage();
  }, true);

  window.addEventListener('storage', function (e) { if (e.key === KEY) { refreshAll(); renderPage(); } });

  /* ---- /pages/wishlist ---- */
  /* Recently viewed comes from the theme's own history (Empire writes localStorage keys named
     "pxu-recentlyViewed-<currency>-<root>" on every product page: [{handle, timestamp}]).
     All such keys are merged, newest first. Saved products and the shipping-protection product
     are left out. */
  var RECENT_MAX = 20;  /* carousel: every product the theme remembers */
  function recent() {
    var seen = {}, out = [];
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (!k || k.indexOf('pxu-recentlyViewed-') !== 0) continue;
        var arr = JSON.parse(localStorage.getItem(k) || '[]');
        if (Array.isArray(arr)) arr.forEach(function (r) { if (r && typeof r.handle === 'string') out.push(r); });
      }
    } catch (e) {}
    out.sort(function (a, b) { return (b.timestamp || 0) - (a.timestamp || 0); });
    return out.map(function (r) { return r.handle; }).filter(function (h) {
      if (seen[h] || h === 'shipping-protection-1') return false;
      seen[h] = true; return true;
    });
  }
  function fetchProduct(h) {
    return fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function cardHtml(p, mode) {
    var variants = p.variants || [];
    var avail = variants.filter(function (v) { return v.available; });
    var img = p.featured_image ? String(p.featured_image).replace(/^\/\//, 'https://') : '';
    if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=500';
    var action;
    if (!avail.length) action = '<button class="ac-wl-btn" type="button" disabled>Sold out</button>';
    else if (variants.length === 1) action = '<button class="ac-wl-btn" type="button" data-ac-wl-add="' + avail[0].id + '">Add to cart</button>';
    else action = '<a class="ac-wl-btn" href="' + esc(p.url) + '">Choose options</a>';
    var heart = mode === 'recent'
      ? '<button type="button" class="ac-wl-heart" data-ac-wl="' + esc(p.handle) + '" data-ac-wl-title="' + esc(p.title) + '" aria-pressed="false" aria-label="Save ' + esc(p.title) + ' to wishlist" title="Save to wishlist">' + HEART + '</button>'
      : '';
    var extra = mode === 'saved'
      ? '<button class="ac-wl-remove" type="button" data-ac-wl-remove="' + esc(p.handle) + '">Remove</button>'
      : '';
    return '<div class="ac-wl-card">' +
      '<div class="ac-wl-card__media"><a class="ac-wl-card__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' + heart + '</div>' +
      '<div class="ac-wl-card__body">' +
        '<a class="ac-wl-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<div class="ac-wl-card__price">' + (variants.length > 1 && p.price_varies ? 'From ' : '') + money(p.price) + '</div>' +
        '<div class="ac-wl-card__stock">' + (avail.length ? 'In stock' : 'Currently sold out') + '</div>' +
        '<div class="ac-wl-card__actions">' + action + extra + '</div>' +
      '</div></div>';
  }
  function tileHtml(p) {
    var img = p.featured_image ? String(p.featured_image).replace(/^\/\//, 'https://') : '';
    if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=300';
    var variants = p.variants || [];
    return '<div class="ac-wl-rv__tile">' +
      '<a class="ac-wl-rv__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
      '<button type="button" class="ac-wl-heart" data-ac-wl="' + esc(p.handle) + '" data-ac-wl-title="' + esc(p.title) + '" aria-pressed="false" aria-label="Save ' + esc(p.title) + ' to wishlist" title="Save to wishlist">' + HEART + '</button>' +
      '<div class="ac-wl-rv__body"><a class="ac-wl-rv__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<div class="ac-wl-rv__price">' + (variants.length > 1 && p.price_varies ? 'From ' : '') + money(p.price) + '</div></div></div>';
  }
  function wireCarousel(root) {
    var track = root.querySelector('.ac-wl-rv__track');
    if (!track) return;
    var prev = root.querySelector('[data-ac-rv-prev]'), next = root.querySelector('[data-ac-rv-next]');
    function upd() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8 }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8 }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
  var pageBusy = false, pageAgain = false;
  function renderPage() {
    var root = document.querySelector('[data-ac-wishlist-page]');
    if (!root) return;
    if (pageBusy) { pageAgain = true; return; }
    var saved = read();
    var rec = recent().filter(function (h) { return saved.indexOf(h) === -1; }).slice(0, RECENT_MAX);
    pageBusy = true;
    if (!root.querySelector('.ac-wl-page')) root.innerHTML = '<div class="ac-wl-page"><p class="ac-wl-page__intro">Loading…</p></div>';
    Promise.all([Promise.all(saved.map(fetchProduct)), Promise.all(rec.map(fetchProduct))]).then(function (res) {
      pageBusy = false;
      if (pageAgain) { pageAgain = false; renderPage(); return; }
      var sp = res[0], rp = res[1];
      var gone = [];
      var savedCards = sp.map(function (p, i) { if (!p || !p.handle) { gone.push(saved[i]); return ''; } return cardHtml(p, 'saved'); }).join('');
      var recentCards = rp.filter(function (p) { return p && p.handle; }).map(tileHtml).join('');
      if (gone.length) { try { localStorage.setItem(KEY, JSON.stringify(read().filter(function (h) { return gone.indexOf(h) === -1; }))); } catch (e) {} refreshAll(); }
      var html = '<div class="ac-wl-page">';
      if (savedCards) {
        html += '<p class="ac-wl-page__intro">Saved on this device. Add to cart when you are ready.</p><div class="ac-wl-grid">' + savedCards + '</div>';
      } else {
        html += '<div class="ac-wl-empty"><p>Your wishlist is empty.</p><p>' +
          (recentCards ? 'Tap the heart on anything you have looked at below, or on any product in the store, to save it here.' : 'Tap the heart on any product to save it here.') +
          '</p><p><a href="' + esc(ROOT) + 'collections/autochimp-catalog">Browse the full catalogue</a></p></div>';
      }
      if (recentCards) {
        html += '<section class="ac-wl-rv" aria-label="Recently viewed"><div class="ac-wl-rv__head"><h2 class="ac-wl-rv__title">Recently viewed</h2>' +
          '<div class="ac-wl-rv__nav"><button type="button" class="ac-wl-rv__arrow" data-ac-rv-prev aria-label="Scroll back">&#8249;</button><button type="button" class="ac-wl-rv__arrow" data-ac-rv-next aria-label="Scroll forward">&#8250;</button></div></div>' +
          '<div class="ac-wl-rv__track">' + recentCards + '</div></section>';
      }
      html += '</div>';
      root.innerHTML = html;
      wireCarousel(root);
      refreshAll();
    });
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('[data-ac-wl-remove]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-ac-wl-remove')); renderPage(); return; }
    var add = e.target.closest && e.target.closest('[data-ac-wl-add]');
    if (add) {
      e.preventDefault();
      add.disabled = true; add.textContent = 'Adding…';
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(add.getAttribute('data-ac-wl-add')), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = ROOT + 'cart'; })
        .catch(function () { add.disabled = false; add.textContent = 'Could not add - open the product'; });
    }
  });

  function init() {
    decorateHeader();
    decorateProductPage();
    decorateCards(document);
    renderPage();
    if (window.MutationObserver) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { decorateCards(document); decorateHeader(); decorateProductPage(); }, 120); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.ACWishlist = { read: read, toggle: toggle, remove: remove };
})();
